import { classifyEnvironmentId } from "../environments/environmentIdClassification";

/**
 * Can this route segment name an environment at all?
 *
 * The chat thread route is a two-segment catch-all, so any unknown path with
 * two segments falls into it (`/settings/models` renders "settings" as an
 * environment id and hangs on the thread loading shell forever). The gate
 * asks the opposite of classification: not "which environment is this" but
 * "could this string be one". The shapes an environment id actually takes:
 *
 * - the cloud shapes `classifyEnvironmentId` decides (`env_…` durable,
 *   `cmmd-runtime:…` legacy, `cmmd-cloud-project:…` placeholder)
 * - the local server's primary id, a UUIDv4 persisted or generated in
 *   `ServerEnvironment`
 * - the desktop's device runtime id, `runtime_` + a UUID, minted per install
 *   (`desktopInstallationIdentity`)
 *
 * A segment matching none of these (`settings`, `models`) is a route path,
 * not an environment, and the thread route throws not-found for it instead of
 * rendering a loading shell that never resolves.
 */

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const DEVICE_RUNTIME_ID_PATTERN =
  /^runtime_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isThreadRouteEnvironmentId(environmentId: string): boolean {
  if (classifyEnvironmentId(environmentId).isCloud) return true;
  if (UUID_PATTERN.test(environmentId)) return true;
  return DEVICE_RUNTIME_ID_PATTERN.test(environmentId);
}
